<div class="grid" [style.background-color]="BackgroundColor" [ngGrid]="GridConfig" (OnInitGrid)="OnGridInit($event)">
              <WidgetPlaceholder  [componentData]="widget.componentdata" 
                                  *ngFor="let widget of widgets; let i = index" 
                                  class="grid-item" (onResizeStop)="OnResize(widget)"
                                  [ngGridItem]="widget.config"> 
              </WidgetPlaceholder>      
</div>

